module.exports = __webpack_public_path__ + "static/media/menu-wally.e155d44c.svg";